import { useEffect, useRef } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Invite } from '@/api';
import { useOpenApi } from '@/common/providers/open-api-provider';
import { addOrUpdateInviteCache } from './company-cache';

export function useFetchInvites(): {
    status: 'error' | 'success' | 'pending';
    invites: Invite[] | undefined;
    refetch: () => void;
} {
    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    const queryClient = useQueryClient();

    const { status, data, refetch } = useQuery({
        queryKey: ['fetchInvites'],
        queryFn: () => {
            return openApiRef.current.invites.getInvites().then((response) => {
                const invites = response.data.data.invites;
                invites.forEach((invite) => {
                    addOrUpdateInviteCache(queryClient, invite);
                });
                return invites;
            });
        }
    });

    return {
        status,
        invites: data,
        refetch: () => {
            void refetch();
        }
    };
}
